import { gql, useMutation } from '@apollo/client';

export const MATCH_OFFER_MUTATION = gql`
    mutation ($offerGuids: [String]!) {
        matchOffer(offerGuids: $offerGuids) {
            id
            guid
            status
            firstServiceDate
            lastServiceDate
            comments
            directCareHours
            midLevelSupervisionHours
            highLevelSupervisionHours
            groupCareHours
            provideAllEstimatedHours
            offerHourPercentage
            clinic {
                location
                street
                city
                stateCode
                zipCode
                longitude
                latitude
            }
            provider {
                guid
                name
                numOfAcceptedOffers
            }
        }
    }
`;

export const useMatcheOffer = () => {
    const [
        execute,
        {
            error,
            loading
        }
    ] = useMutation(MATCH_OFFER_MUTATION);


    return {
        execute,
        error,
        loading
    };
};
